export enum HemaActivationRoutesEnum {
    TokenProcessing = 'direct-regelen',
    ChangePassword = 'wachtwoord-wijzigen',
    ProvideEmail = 'email-opgeven'
}
